// Check if user session exists in sessionStorage on initial load
const hasSession = () => {
  try {
    const user = sessionStorage.getItem("5r_user");
    return user !== null;
  } catch (e) {
    return false;
  }
};

const loggedReducer = {
  isAuthenticated: (state = hasSession(), action) => {
    switch (action.type) {
      case "LOG_IN":
        return true;
      case "LOG_OUT":
        // Remove the user details from the session storage
        sessionStorage.removeItem("5r_user");
        return false;
      default:
        return state;
    }
  },
  profile: (state = null, action) => {
    // Initialize state from sessionStorage if available
    if (state === null) {
      try {
        const storedUser = sessionStorage.getItem("5r_user");
        state = storedUser ? JSON.parse(storedUser) : { id: "", name: "", role: "", permissions: [] };
      } catch (e) {
        state = { id: "", name: "", role: "", permissions: [] };
      }
    }
    
    switch (action.type) {
      case "SET_PROFILE":
        // Set the user details in the session storage
        sessionStorage.setItem("5r_user", JSON.stringify(action.payload));
        return action.payload;
      default:
        return state;
    }
  },
  isLoggingOut : (state = false, action) => {
    switch (action.type) {
      case "LOGGING_OUT":
        return action.payload
      default:
        return state;
    }
  }
};

export default loggedReducer;
